import instance from '../Services/interceptor';

export const getScheduleUploadListAPI = async () => {
  const { data } = await instance.get(
    `/Candidate/file/upload/history?uploadHistoryType=ExamSchedule`
  );
  return data;
};
